module.exports = __webpack_public_path__ + "static/tech_bg-43fec87e141538235557e1d1efffbb8d.png";